export enum MetadataViewType {
  Browser = "Browser",
  QcTool = "QcTool",
  Search = "Search",
}
